import React from "react";
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import Header from '../../components/common/header/Header';
import Footer from '../../components/common/Footer';
import { setCurMenuAction, setHeaderTransferAction } from "../../modules/common/headerModule";
import { useDispatch, useSelector } from "react-redux";
import SearchBrandListTop from '../../components/search/SearchBrandListTop';
import SearchLangFindFilter from '../../components/search/SearchLangFindFilter';
import SearchBrandProductListContainer from '../../components/search/SearchBrandProductListContainer';
import { brandAction, nobrandAction, setClipBrandIdAction, setNoBrandIdAction } from '../../modules/su/userBrandModule';
import {isMobileOnly} from 'react-device-detect';
import TagManager from 'react-gtm-module';
import { setSearchTextAction } from '../../modules/search/searchModule';
import queryString from "query-string";
import { useHistory } from 'react-router-dom';

const SearchMainBlock = styled.div`
    ${!isMobileOnly&&"min-width: 1236px"};
`;

const SearchContentsBlock = styled.div`
    ${!isMobileOnly&&`
        width: 100%;
        max-width: 1176px;    
    `};
    margin: 0 ${isMobileOnly?"4vw":"auto"};
    padding-top: 80px
`;

const SearchSectionBlock = styled.div`
    ${isMobileOnly?`
    padding: 0px 0 120px;
    `:`
    padding: 90px 0 120px;
    `};
`;

const SearchSectionWrapBloc = styled.div`
    width: 100%;
    max-width: 1176px;
    margin: 0 auto;
`;

const SearchResultTitleBlock = styled.div`
    ${isMobileOnly?`
    margin-bottom: 60px;
    `:`
    margin-bottom: 80px;
    `};
`;

const SearchResultTitleH2Block = styled.h2`
    ${isMobileOnly?`
    margin: 40px 0 30px;
    font-size: 14px;
    `:`
    margin-bottom: 40px;
    font-size: 32px;
    text-align: center;
    `};

    margin-bottom: 40px;
    font-weight: 500;
    position: relative;
`;

const SearchRightLinkBlock = styled.div`
    ${isMobileOnly?`
    top: -40px;
    font-size: 14px;
    `:`
    top: -40px;
    font-size: 20px;
    `};

    right: 0;
    position: absolute;
    color: #111111;
    font-weight: 500;
    cursor: pointer;

    ::after {
        content: '';
        display: inline-block;
        width: 10px;
        ${isMobileOnly?`
        height: 12px;
        `:`
        height: 18px;
        `};
        
        margin-left: 5px;
        //background: url(/assets/images/icon/cate_plus.png) center center/cover no-repeat;
        background: url(/assets/images/icon/arrow_left.svg) center center no-repeat;
        //background: url(/assets/images/icon/faq_arrow-icon.png) center center/cover no-repeat;
        -webkit-transform: rotate(180deg);
        -ms-transform: rotate(180deg);
        transform: rotate(180deg);
    }
`;

const SearchMain = ({ match, location }) => {
    const dispatch = useDispatch();
    const [search, setSearch] = useState(null);
    const history = useHistory();

    const { searchText, statInfo, errorStat, brandInfo, brandDefaultInfo, accessToken, id } = useSelector(
        ({ searchReducer, loadingReducer, userReducer }) => ({
            searchText: searchReducer.searchText,
            statInfo: searchReducer.statInfo,
            errorStat: searchReducer.errorStat,
            brandInfo: searchReducer.brandInfo,
            brandDefaultInfo: searchReducer.brandDefaultInfo,
            accessToken: userReducer.accessToken,
            id: userReducer.id,
        })
    );

    // 최초 실행시 Header 관련 처리 추가
    useEffect(() => {
        dispatch(setCurMenuAction('searchBrand'));
        dispatch(setHeaderTransferAction(false));
        //console.log("SearchMain start");
        window.scrollTo(0, 0);

    }, []);

    /* useEffect(() => {
        if (searchText !== null && searchText.length > 0) {
            dispatch(getStatAction(searchText));
        }
    }, []) */

    useEffect(() => {
        window.scrollTo(0, 0);
        if(!!searchText&&searchText.length){
            const tagManagerArgs = {
                dataLayer: {
                    event: 'search',
                    keyword: searchText
                }
            }
            TagManager.dataLayer(tagManagerArgs);
        }
    }, [searchText])

    useEffect(() => {
        if (accessToken !== null) {
            dispatch(brandAction(id));
        }
        else {
            dispatch(setClipBrandIdAction(null));
        }
    }, [accessToken]);

    useEffect(() => {
        parseUrl(location, match);
    }, [location, match]);

    const parseUrl = (location, match) => {
        let query = queryString.parse(location.search);
        let search = null;

        if(query && query.q && query.q !== undefined) {
            setSearch(query.q);
            search = query.q;
            if(search !== searchText) {
                dispatch(setSearchTextAction(search));
            }
        } else {
            setSearch(null);
            dispatch(setSearchTextAction(""));
        }

        
        window.scrollTo(0, 0);
    }
    const getShowBlock = () => {
        if (searchText !== null && searchText.length > 0) {
            if (statInfo !== null && statInfo.totalnum > 0) {
                return 'block';
            }
            else {
                return 'none';
            }
        }

        return 'none';
    }

    const onClickProd = () => {
        if (searchText === null || (searchText != null && searchText.length === 0)) {
            history.replace("/search");
        } else {
            history.replace("/search?q="+searchText);
        }
    }

    const getTitle = () => {
        if (searchText === null || (searchText != null && searchText.length === 0)) {
            return "검색어를 입력해주세요.";
        }
        else {
            if (brandInfo !== null && brandInfo.totalnum === 0 && statInfo !== null && statInfo.totalnum === 0) {
                let stringTitle = "\"" + "<span style='font-weight:700'>" + searchText + "</span>" + "\"" + " 찾으시는 검색 결과가 없어요 :-(";
                return stringTitle;
            }
            else if ((brandInfo !== null && brandInfo.totalnum >= 0) && (statInfo !== null && statInfo.totalnum >= 0)) {
                let stringTitle = "\"" + "<span style='font-weight:700'>" + searchText + "</span>" + "\"" + " 검색결과" + " 상품 " + "<span style='font-weight:700'>" + Number(statInfo.totalnum.toFixed(1)).toLocaleString() + "</span>" + "개, " + "브랜드 " + "<span style='font-weight:700'>" + brandInfo.totalnum + "</span>" + "개";
                return stringTitle;
            }
        }
    }

    return (
        <SearchMainBlock>
            <Header />
            <SearchContentsBlock>
                <SearchSectionBlock>
                    <SearchSectionWrapBloc>
                        <SearchResultTitleBlock >
                            <SearchResultTitleH2Block style={{ fontWeight: '400' }}>
                                {<div dangerouslySetInnerHTML={{ __html: getTitle() }}/>}
                                <SearchRightLinkBlock onClick={onClickProd}>상품 검색</SearchRightLinkBlock>
                            </SearchResultTitleH2Block>
                        </SearchResultTitleBlock>
                        <SearchBrandListTop />
                        <SearchLangFindFilter showBlock={getShowBlock()} />
                        <SearchBrandProductListContainer />
                    </SearchSectionWrapBloc>
                </SearchSectionBlock>

            </SearchContentsBlock>
            <Footer />
        </SearchMainBlock>
    );
};

export default SearchMain;
